<template>
  <div class="card px-2 pt-3 mb-4 shadow-sm d-flex">
    <div class="col-12 p-0 m-0">
        <LoadingSpinner v-if="!oliverSalesLoaded" />
        <div class="row p-0 m-0" v-else>
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm"
                  >Sale</span
                >
              </div>
            <IndustrySearch
              :option_list="userOliverSales"
              :default_values="userOliverSale"
              :key="3"
              :multiple="false"
              :isDisabled="savingOliverUser || isUserOliverSale"
              @selected="selectOliverSale"
              class="form-control inline-table"
            />
          </div>

          <div
            v-if="loadingDataSale && userOliverSale[0] != '0'"
            class="d-flex col-12 col-md-6 justify-content-end py-0 my-0"
          >
            <span class="loadingres spinner-border loading-spinner text-primary">
            </span>
          </div>
          <div class="col-6 m-0 py-0 px-2 text-right">
            <div class="p-0 m-0" v-if="!loadingDataSale && userOliverSale[0] != '0'">

              <span class="mx-0 p-0" v-if="saleRankingData.total">
                <img                  
                  class="ml-1"
                  :src="logoRevenueRanking(saleRankingData.total)"
                  height="78px"                  
                /></span>
              <span class="mx-0" v-if="userOliverSale[0] != 'all'">
                 <img
                  v-if="saleRankingData.avatar"                  
                  class="ml-1 rounded-circle shadow"
                  :src="saleRankingData.avatar"
                  height="70px"                  
                />
                <img
                  v-else
                  class="ml-1 rounded-circle shadow"
                  :src="require('@/assets/images/emptyperson.png')"
                  height="70px"
                />
              </span>
            </div>
          </div>
        </div>
    </div>

    <div
      class="d-flex flex-row justify-content-center py-0 my-0 w-100 pt-4"
      v-if="userOliverSale[0] == '0' && oliverSalesLoaded"
    >
      <div class="col-lg-12 pt-2 text-center py-0">
        <img
          src="@/assets/images/search-oliver3.png"
          class="rounded mx-auto d-block py-0"
          width="180px"
        />
      </div>
    </div>
   
    <LoadingSpinner v-if="!allLoadings && userOliverSale[0] != '0'" />
    <div class="col-12 mt-3" v-if="allLoadings && userOliverSale[0] != '0'">
     
      <!-- Clients -->
      <div class="row">
        <div class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ month }}
                </th>
                <th>Total / AVG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dataClient, index) in dataClientMonths" :key="index">
                <td  width="160px">{{ dataClient.label }}</td>
                <td v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ (getMonthData('dataClientMonths', dataClient.id, month)) ? getMonthData('dataClientMonths', dataClient.id, month) : '-' }}
                </td>
                <td>
                  {{ getTotalAVG(dataClient.id, 'dataClientMonths') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

        <!-- Performances -->
      <div class="row mt-4">
        <div class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ month }}
                </th>
                <th>Total / AVG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dataPerformance, index) in dataPerformanceMonths" :key="index">
                <td width="160px">{{ dataPerformance.label }}</td>
                <td v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ (getMonthData('dataPerformanceMonths', dataPerformance.id, month)) ? getMonthData('dataPerformanceMonths', dataPerformance.id, month) : '-' }}
                </td>
                <td>
                  {{ getTotalAVG(dataPerformance.id, 'dataPerformanceMonths') }}
                </td>                    
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Sale -->
      <div class="row mt-4">
        <div class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ month }}
                </th>
                <th>Total / AVG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dataSale, index) in dataSaleMonths" :key="index">
                <td width="160px">{{ dataSale.label }}</td>
                <td v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ (getMonthData('dataSaleMonths', dataSale.id, month)) ? getMonthData('dataSaleMonths', dataSale.id, month) : '-' }}
                </td>
                <td>
                  {{ getTotalAVG(dataSale.id, 'dataSaleMonths') }}
                </td>                    
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Problem -->
      <div class="row mt-4">
        <div class="col-12">
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ month }}
                </th>
                <th>Total / AVG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dataPrroblem, index) in dataProblemMonths" :key="index">
                <td width="160px">{{ dataPrroblem.label }}</td>
                <td v-for="(month, index) in getLastEightMonths" :key="index">
                  {{ (getMonthData('dataProblemMonths', dataPrroblem.id, month)) ? getMonthData('dataProblemMonths', dataPrroblem.id, month) : '-'}}
                </td>
                <td>
                  {{ getTotalAVG(dataPrroblem.id, 'dataProblemMonths') }}
                </td>                    
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService } from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from 'moment';
import { mapState} from "vuex";



export default {
  name: 'GlobalMetrics',

  components: {
    IndustrySearch,
    LoadingSpinner,
  },

  data() {
    return {
      revenue_ranking: [
        { id: 1, img: '1_novice_closer.png',label: 'Novice Closer', min: 0, max: 15000},
        { id: 2, img: '2_deal_maker.png',label: 'Deal Maker', min: 15001, max: 40000},
        { id: 3, img: '3_sales_navigator.png',label: 'Sales Navigator', min: 40001, max: 80000},
        { id: 4, img: '4_revenue_builder.png',label: 'Revenue Builder', min: 80001, max: 150000},
        { id: 5, img: '5_growth_catalyst.png',label: 'Growth Catalyst', min: 150001, max: 250000},        
        { id: 6, img: '6_campaign_master.png',label: 'Campaign Master', min: 250001, max: 400000},
        { id: 7, img: '7_lead_strategist.png',label: 'Lead Strategist', min: 400001, max: 600000},
        { id: 8, img: '8_deal_architech.png',label: 'Deal Architect', min: 600001, max: 900000},
        { id: 9, img: '9_revenue_guru.png',label: 'Revenue Guru', min: 900001, max: 1200000},
        { id: 10,img: '10_b2b_rainmaker.png', label: 'B2B Rainmaker', min: 1200001, max: 5200000},
      ],
      saleRankingData: null,
      loadingDataSale: true,
      savingOliverUser: false,
      userOliverSale: ["0"],
      userOliverSales: [{ id: "0", label: "Select option..."}, { id: "all", label: "All"}],
      //userOliverSales: [{id: "0", label: "Select option..."}],
      oliverSalesLoaded: false,
      allLoadings: false,         
      monthsWithData:[],
      dataClientMonths: [
        { id: 'total_client_active', label: 'Active clients', data: [], calculateAVG: true},
        { id: 'total_client_standby', label: 'Paused clients', data: [], calculateAVG: true},
        { id: 'total_client_decliened_or_recovery', label: ' Recovery clients', data: [], calculateAVG: true},
        { id: 'total_client_deleted', label: 'Deleted clients', data: [], calculateAVG: true},
      ],
      dataPerformanceMonths: [
        { id: 'revenue', label: 'Revenue', data: [], calculateAVG: false},
        { id: 'revenue_orders', label: 'Revenue / Orders', data: [], calculateAVG: true},
        { id: 'meeting_orders', label: ' Meetings / orders', data: [], calculateAVG: true},
        { id: 'conversion_rate', label: 'Conversion rate', data: [], calculateAVG: true},
      ],
      dataSaleMonths: [
        { id: 'new_clients', label: 'New clients', data: [], calculateAVG: false},
        { id: 'new_orders', label: 'New order (new client)', data: [], calculateAVG: false},
        { id: 'total_orders', label: 'New orders (old clients)', data: [], calculateAVG: false},
        { id: 'avg_meeting_price', label: 'AVG meeting price', data: [], calculateAVG: true},
      ],
      dataProblemMonths: [
        { id: 'avg_lcm', label: 'AVG LCM', data: [], calculateAVG: true},
        { id: 'avg_lom', label: 'AVG LOM', data: [], calculateAVG: true},
        { id: 'avg_com', label: 'AVG COM', data: [], calculateAVG: true},
        { id: 'avg_wac', label: 'AVG WAC', data: [], calculateAVG: true},
      ],
    };
  },

  created() {
    this.init()
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isUserOliverSale() {
      return (this.user.role_id == 1 && this.user.user_constraint_id == 2);
    },
    logoRevenueRanking() {
      return (total) => {
        const image = this.revenue_ranking.find(el => (Number(total) >= el.min && Number(total) <= el.max )).img
        return require(`@/assets/images/revene_ranking/mini/${image}`);
      };
    },
    getTotalAVG(){
      return (type, data) => {
        const value = this[data].filter(el => el.id === type)[0].data.find( e => e.total_avg)
        if(value && value.total != '-'){
          return value.total.toFixed(2)
        } else {
          return '-'
        }
      }
    },
    getLastEightMonths () {
      const months = [];
      for (let i = 9; i >= 0; i--) {
        months.push(moment().subtract(i, 'months').format('YYYY-MM'));
      }
      return months;
    },
    getMonthData(){
      return (type, item, month) => {
        if(type === 'dataClientMonths'){
          const dataByMonth = this.dataClientMonths.find(el => el.id == item).data
          if(dataByMonth){
            const existMonth = dataByMonth.find(el => el.month == month)
            if(existMonth){
              return existMonth.total
            }
          }
        }

        if(type === 'dataPerformanceMonths'){
          const dataByMonth = this.dataPerformanceMonths.find(el => el.id == item).data
          if(dataByMonth){
            const existMonth = dataByMonth.find(el => el.month == month)
            if(existMonth){
              return Number(existMonth.total).toFixed(2)
            }
          }
        }

        if(type === 'dataSaleMonths'){
          const dataByMonth = this.dataSaleMonths.find(el => el.id == item).data
          if(dataByMonth){
            const existMonth = dataByMonth.find(el => el.month == month)
            if(existMonth){
              return Number(existMonth.total).toFixed(0)
            }
          }
        }

        if(type === 'dataProblemMonths'){
          const dataByMonth = this.dataProblemMonths.find(el => el.id == item).data
          if(dataByMonth){
            const existMonth = dataByMonth.find(el => el.month == month)
            if(existMonth){
              return existMonth.total
            }
          }
        }
      }
    },
  },

  methods: {

    initData() {
      this.dataClientMonths.forEach((el) => {
        el.data = [];
      });
      this.dataPerformanceMonths.forEach((el) => {
        el.data = [];
      });
      this.dataSaleMonths.forEach((el) => {
        el.data = [];
      });
      this.dataProblemMonths.forEach((el) => {
        el.data = [];
      });
    },

    init(){
      this.getUserOliverSales()
    },

    getUserOliverSales(){
      usersService.getUserOliverSales(true, 0 , true)
      .then( res => {
        if(res.result.length > 0) {
          const userOliverSalesWithlabel = res.result.map( el => ({ ...el, label: el.lastname + ", " + el.name}))
          this.userOliverSales.push(...userOliverSalesWithlabel)
          this.oliverSalesLoaded = true

          if(this.isUserOliverSale) {
            const findUserOliverSale = this.userOliverSales.find(el => el.id == this.user.id)
            if(findUserOliverSale) {
              this.userOliverSale = [findUserOliverSale.id]
              this.getDataMonths()
            }
          }
        }
      })
      .catch( err => console.err(err))
    },

    selectOliverSale(value){
      this.initData();
      this.userOliverSale[0] = value.id;
      if(value.id != 0){
        this.loadingDataSale = true
        this.getDataMonths()
        this.getDataAboutThisSale(value.id)
      }
    },

    getDataAboutThisSale(oliser_sale_id){
       usersService.getOliveSaleAllRevenue(oliser_sale_id)
          .then( res => {
            if (res.result){
              this.saleRankingData = res.result
            }
            this.loadingDataSale = false
          })
    },

    async getDataMonths() {
      this.allLoadings = false;

      try {
        await Promise.all([
          // Clients
          usersService.getOliverSalesDashboardMonhts("clients", this.userOliverSale[0])
            .then(res => {
              if (res.result) {
                const data = this.calculateTotalAVG('dataClientMonths', res.result);
                this.dataClientMonths[0].data = data.filter(el => el.label === 'total_client_active');
                this.dataClientMonths[1].data = data.filter(el => el.label === 'total_client_standby');
                this.dataClientMonths[2].data = data.filter(el => el.label === 'total_client_decliened_or_recovery');
                this.dataClientMonths[3].data = data.filter(el => el.label === 'total_client_deleted');

                const monthsAvailable = this.dataClientMonths[0].data.map(el => el.month);
                if (monthsAvailable) {
                  this.monthsWithData = monthsAvailable.sort((a, b) => a.localeCompare(b));
                }
              }
            }),

          // Performances
          usersService.getOliverSalesDashboardMonhts("performances", this.userOliverSale[0])
            .then(res => {
              if (res.result) {
                const data = this.calculateTotalAVG('dataPerformanceMonths', res.result);
                this.dataPerformanceMonths[0].data = data.filter(el => el.label === 'revenue');
                this.dataPerformanceMonths[1].data = data.filter(el => el.label === 'revenue_orders');
                this.dataPerformanceMonths[2].data = data.filter(el => el.label === 'meeting_orders');
                this.dataPerformanceMonths[3].data = data.filter(el => el.label === 'conversion_rate');

                const monthsAvailable = this.dataClientMonths[0].data.map(el => el.month);
                if (monthsAvailable) {
                  this.monthsWithData = monthsAvailable.sort((a, b) => a.localeCompare(b));
                }
              }
            }),

          // Sales
          usersService.getOliverSalesDashboardMonhts("sales", this.userOliverSale[0])
            .then(res => {
              if (res.result) {
                const data = this.calculateTotalAVG('dataSaleMonths', res.result);
                this.dataSaleMonths[0].data = data.filter(el => el.label === 'new_clients');
                this.dataSaleMonths[1].data = data.filter(el => el.label === 'new_orders');
                this.dataSaleMonths[2].data = data.filter(el => el.label === 'total_orders');
                this.dataSaleMonths[3].data = data.filter(el => el.label === 'avg_meeting_price');

                const monthsAvailable = this.dataClientMonths[0].data.map(el => el.month);
                if (monthsAvailable) {
                  this.monthsWithData = monthsAvailable.sort((a, b) => a.localeCompare(b));
                }
              }
            }),

          // Problems
          usersService.getOliverSalesDashboardMonhts("problems", this.userOliverSale[0])
            .then(res => {
              if (res.result) {
                const data = this.calculateTotalAVG('dataProblemMonths', res.result);
                this.dataProblemMonths[0].data = data.filter(el => el.label === 'avg_lcm');
                this.dataProblemMonths[1].data = data.filter(el => el.label === 'avg_lom');
                this.dataProblemMonths[2].data = data.filter(el => el.label === 'avg_com');
                this.dataProblemMonths[3].data = data.filter(el => el.label === 'avg_wac');

                const monthsAvailable = this.dataClientMonths[0].data.map(el => el.month);
                if (monthsAvailable) {
                  this.monthsWithData = monthsAvailable.sort((a, b) => a.localeCompare(b));
                }
              }
            })
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.allLoadings = true;
      }
    },
    calculateTotalAVG(type, data){
       this[type].forEach( el => {
        const hasData = data.filter(e => e.label == el.id)
        if(hasData){
            const total = el.calculateAVG ? (hasData.reduce((acc, val) => Number(acc) + Number(val.total), 0) / hasData.length ) : hasData.reduce((acc, val) => Number(acc) + Number(val.total), 0) ;
            data.push({ label: el.id, total_avg: true,  total: (total) ? total : '-' })
        }
        })
        return data
    }
      
  },

};
</script>
